import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-custom-sources',
  templateUrl: './help-custom-sources.component.html',
  styleUrls: ['./help-custom-sources.component.scss']
})
export class HelpCustomSourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
